import axios from "axios";
import { getBaseUrl } from "./config";

const baseURL = getBaseUrl();

export default axios.create({
  baseURL: baseURL,
});

export const axiosPrivate = axios.create({
  baseURL: baseURL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});
